var map = {
	"./dashboard/dashboard.module": [
		"../../../../../src/app/dashboard/dashboard.module.ts",
		"dashboard.module"
	],
	"app/accountGoals/account-goals.module": [
		"../../../../../src/app/accountGoals/account-goals.module.ts",
		"account-goals.module"
	],
	"app/goals/goals.module": [
		"../../../../../src/app/goals/goals.module.ts",
		"goals.module"
	],
	"app/projects/projects.module": [
		"../../../../../src/app/projects/projects.module.ts",
		"projects.module"
	],
	"app/work-from-home/work-from-home.module": [
		"../../../../../src/app/work-from-home/work-from-home.module.ts",
		"work-from-home.module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "../../../../../src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// /home/agira/Desktop/BU-Intra/agira-intranet-ui/src/$$_lazy_route_resource lazy
// module id = ../../../../../src/$$_lazy_route_resource lazy recursive
// module chunks = main